/**
 * "How did you hear about us?" options for the details step.
 *
 * Must stay in step with `backend/app/Support/ReferralSource.php` — the labels
 * are the stored values and the API rejects anything not on this list.
 */
export const REFERRAL_SOURCES = [
  'Social Media',
  'Search Engine',
  'Friends & Family',
  'Event',
  'Media: TV/Radio',
] as const;

export type ReferralSource = (typeof REFERRAL_SOURCES)[number];
